import React from "react";
import ImageBanner from "@/components/ImageBanner";
import Footer from "@/layout/Footer";
import { Link } from "react-router-dom";
const PageNotFound = () => {
	return (
		<>
			<div className="relative flex flex-col hidden lg:flex w-full h-auto items-center justify-center mt-[40px]">
				<div className="w-full max-w-[1440px] flex items-center justify-between px-8">
					<ImageBanner
						type="desktop"
						title="RBETRAJ"
						containerWidth="w-full max-w-[1440px] flex items-center"
						titlePosition={{ top: "top-[100px]", left: "left-[60px]" }}
					/>
				</div>
			</div>

			<div className="relative flex flex-col hidden lg:flex w-full  items-center justify-center h-[500px]">
				<div className="w-full max-w-[1350px] flex items-center justify-center border border-gray-200 shadow">
					<div className="flex justify-center w-[512px] h-[207px] flex flex-col gap-[16px] rounded-[8px] pt-[16px] pr-[20px] pb-[32px] pl-[20px] items-center">
						{/* Icon */}
						<div className="w-[48px] h-[48px]  rounded-[28px] flex items-center justify-center">
							<img
								src="/assets/page-not-found/notFound.svg"
								alt="Error Icon"
								className="w-[24px] h-[24px]"
							/>
						</div>

						{/* Card content */}
						<div className="flex flex-col items-center text-center gap-[8px]">
							<p className="font-montserrat font-[600] text-[20px] leading-[32px] text-[#101828]">
								Something went wrong...
							</p>
							<p className="font-montserrat font-[400] text-[14px] leading-[100%] text-[#667085]">
								We had some trouble loading this page. Please refresh the page
								to try again or get in touch if the problem sticks around!
							</p>
						</div>

						{/* Buttons */}
						<div className="flex gap-[8px] mt-[16px]">
							<Link to="/">
								<button className="w-[112px] h-[32px] border border-[#193D34] rounded-[24px] px-[8px] flex items-center justify-center font-montserrat font-[500] text-[13px] leading-[24px] text-white bg-[#193D34]">
									Go To Home
								</button>
							</Link>
							<button
								className="w-[228px] h-[32px] rounded-[24px] px-[8px] flex items-center justify-center font-montserrat font-[500] text-[13px] leading-[24px] text-[#193D34] bg-[#B7D974]"
								onClick={() => window.location.reload()}
							>
								Refresh
							</button>
						</div>
					</div>
				</div>
			</div>
			{/* Mobile View  */}
			<ImageBanner type="mobile" title="RBETRAJ" />
			<div className="flex flex-col flex lg:hidden w-full items-center justify-center  h-[600px]">
				<div className="w-full max-w-[90%] flex items-center justify-center border border-gray-200 shadow">
					<div className="flex justify-center w-full h-auto flex-col gap-[16px] rounded-[8px] pt-[16px] pr-[20px] pb-[32px] pl-[20px] items-center bg-white">
						{/* Icon */}
						<div className="w-[48px] h-[48px] rounded-[28px] flex items-center justify-center">
							<img
								src="/assets/page-not-found/notFound.svg"
								alt="Error Icon"
								className="w-[24px] h-[24px]"
							/>
						</div>

						{/* Card content */}
						<div className="flex flex-col items-center text-center gap-[8px]">
							<p className="font-montserrat font-[600] text-[18px] leading-[28px] text-[#101828]">
								Something went wrong...
							</p>
							<p className="font-montserrat font-[400] text-[14px] leading-[20px] text-[#667085]">
								We had some trouble loading this page. Please refresh the page
								to try again or get in touch if the problem sticks around!
							</p>
						</div>

						{/* Buttons */}
						<div className="flex flex-col sm:flex-row gap-[8px] mt-[16px] w-full items-center justify-center">
							<button
								className="w-full sm:w-[228px] h-[32px] rounded-[24px] px-[8px] flex items-center justify-center font-montserrat font-[500] text-[13px] leading-[24px] text-[#193D34] bg-[#B7D974]"
								onClick={() => window.location.reload()}
							>
								Refresh
							</button>
							<Link to="/" className="w-full sm:w-[112px]">
								<button className="w-full h-[32px] border border-[#193D34] rounded-[24px] px-[8px] flex items-center justify-center font-montserrat font-[500] text-[13px] leading-[24px] text-[#193D34]">
									Go To Home
								</button>
							</Link>
						</div>
					</div>
				</div>
			</div>
			<Footer />
		</>
	);
};

export default PageNotFound;
